import Badge from '@material-ui/core/Badge'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'
import ProductListingIcon, {
    ProductListingIconStatusType,
    ProductListingIconType,
} from './ProductListingIcon'

const useStyles = makeStyles((theme: Theme) => ({
    badgeContainer: {
        width: 36,
        height: 36,
        borderRadius: 360,
        backgroundColor: '#24CEAD',
        right: 15,
        top: -2,
        color: theme.palette.common.white,
        webkitUserSelect: 'none',
        mozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
    },
    badgeRootContainer: {
        width: 'calc(100%)',
        height: 'calc(100%)',
    },
    badgeImg: {
        marginTop: 4,
        marginLeft: 4,
    },
}))

export interface ProductListingCardBadgeProps {
    loading?: boolean
    listingId?: string
    productListingIconType?: ProductListingIconType
}

const ProductListingCardBadge: React.FC<ProductListingCardBadgeProps> = ({
    loading,
    listingId,
    productListingIconType,
    children,
}) => {
    const classes = useStyles()

    if (!listingId && !loading) return null

    return (
        <Badge
            badgeContent={
                <ProductListingIcon
                    iconType={productListingIconType}
                    iconStatusType={ProductListingIconStatusType.BADGE}
                />
            }
            data-testid={`listingCardSelected${listingId}`}
            classes={{
                root: classes.badgeRootContainer,
                badge: classes.badgeContainer,
            }}
            invisible={loading || !productListingIconType}
        >
            {children}
        </Badge>
    )
}

export default ProductListingCardBadge
